// extracted by mini-css-extract-plugin
export var filterIncDec = "_e8-0";
export var leftBorder = "_e8-1";
export var rightBorder = "_e8-2";
export var stringInput = "_e8-3";